import { flow, getParent, types } from 'mobx-state-tree';
import { StreamChat } from 'stream-chat';

import { getCgAdminProfileChats } from '@common/api/chats';

const Chat = types
	.model('Chat', {
		data: types.frozen(),
		userId: types.maybeNull(types.string),
		chatJWT: types.maybeNull(types.string),
	})
	.volatile(() => ({
		unreadCount: 0,
		loading: true,
	}))
	.views((self) => ({
		get client() {
			const store: any = getParent(self);
			const key = store?.streamApiKey || process.env.ENV_STREAM_API_KEY;
			return StreamChat.getInstance(key);
		},
	}))
	.actions((self) => ({
		setUnreadCount(unreadCount: number) {
			self.unreadCount = unreadCount;
		},
	}))
	.actions((self) => ({
		fetch: flow(function* () {
			try {
				self.loading = true;

				const store: any = getParent(self);
				self.userId = `${store.profile.id}`;
				self.chatJWT = store.profile.chatJWT;

				yield self.client.connectUser(
					{
						id: self.userId,
					},
					self.chatJWT,
				);

				self.unreadCount = (self.client.user.total_unread_count as number) || 0;
				self.client.on((event) => {
					if (event.total_unread_count !== undefined) {
						self.setUnreadCount(event.total_unread_count);
					}
				});
			} finally {
				self.loading = false;
			}
		}),

		fetchCgAdminChats: flow(function* () {
			try {
				self.loading = true;

				const result = yield getCgAdminProfileChats();
				self.userId = result.id;
				self.chatJWT = result.chatJWT;

				yield self.client.connectUser(
					{
						id: result.id,
					},
					result.chatJWT,
				);

				self.unreadCount = (self.client.user.total_unread_count as number) || 0;
				self.client.on((event) => {
					if (event.total_unread_count !== undefined) {
						self.setUnreadCount(event.total_unread_count);
					}
				});
			} finally {
				self.loading = false;
			}
		}),
		getCgAdminProfileChats,
	}));

export default Chat;
